/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */

import { Rating } from '@mui/material';

import { ListingById } from '../../types/General';
import { APPROVAL_STATUS } from '../../utils/enums';

type props = {
  type: any;
  details: ListingById | undefined;
};

const VehicleTop = ({ type, details }: props) => {
  return (
    <>
      <div className="cards profile_top">
        <div className="gap_p">
          <div className="left_s" style={{ alignItems: 'flex-start' }}>
            <div className="profile_image">
              <figure>
                <img src={details?.coverImage || ''} alt="Vehicle" />
                {details?.status === Number(APPROVAL_STATUS.APPROVED + 1) ? (
                  <span>
                    <img src="/static/images/verified_icon.svg" alt="Icon" />
                  </span>
                ) : null}
              </figure>
              {/* <p>#CR1987876</p> */}
            </div>
            <div className="profile_info">
              <h2 style={{ marginBottom: '6px' }}>
                <b>{details?.title || '-'}</b>
              </h2>
              <div className="star_rating">
                <Rating
                  name="half-rating"
                  defaultValue={details?.avgRating || 0}
                  precision={0.5}
                  readOnly
                />
              </div>

              <ul className="box_list" style={{ marginTop: '16px' }}>
                <li>
                  <h3>
                    <img
                      src="/static/images/checking.png"
                      alt="Icon"
                      style={{ maxWidth: '20px' }}
                    />{' '}
                    {details?.mileage || 0} kmpl
                  </h3>
                  <p>Mileage</p>
                </li>
                <li>
                  <h3>
                    <img
                      src="/static/images/checking.png"
                      alt="Icon"
                      style={{ maxWidth: '20px' }}
                    />{' '}
                    {details?.engineCapacity?.min}- {details?.engineCapacity?.max} cc
                  </h3>
                  <p>Engine</p>
                </li>
                <li>
                  <h3>
                    <img
                      src="/static/images/checking.png"
                      alt="Icon"
                      style={{ maxWidth: '20px' }}
                    />{' '}
                    {details?.brand?.name || '-'}
                  </h3>
                  <p>Brand</p>
                </li>
              </ul>
            </div>
          </div>
          <div className="right_s">
            <div className="userdetail_card">
              <ul className="fcComment_list">
                <li>
                  <figure style={{ height: '50px', width: '50px' }}>
                    <img
                      src={details?.seller?.image || '/static/images/user_placeholder.png'}
                      alt="Seller"
                    />
                  </figure>
                  <p>
                    <b>{details?.seller?.name || '-'}</b> {details?.seller?.dialCode}{' '}
                    {details?.seller?.phoneNo || '-'} <br />
                    {details?.seller?.email || '-'}
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default VehicleTop;
